import { useEffect, useMemo, useState } from 'react'

export const useDebounce = <T>(
  value: T,
  delay: number,
  defaultValue?: T,
  callback?: () => void,
): T => {
  // defaultValue для интеграции поиска с sessionStorage
  const [debouncedValue, setDebouncedValue] = useState(defaultValue ?? value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
      callback?.()
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return useMemo(() => debouncedValue, [debouncedValue])
}
